import axios from 'axios';

const axiosServices = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3010/' });

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error && error.response ? error.response.status : null;
    const data = error && error.response ? error.response.data : null;

    if (status === 401 && !window.location.href.includes('/login')) {
      window.location.pathname = '/login';
    }

    const serializableError = {
      message: error?.message ?? 'Network Error',
      status,
      data
    };

    return Promise.reject(serializableError);
  }
);

export default axiosServices;
